// import only notification so not all atoms get bundled
import notification from '@atoms/Notification';

import useQuery from './useQuery';
import useMutation from './useMutation';

import api from '..';

export const useGetAppearance = (queryConfig = {}) => {
  const queryResult = useQuery(['appearance'], api.appearance.get, {
    onError: (error) => {
      if (error?.response?.status !== 404) {
        notification.error({ message: error.message });
      }
    },
    ...queryConfig,
  });

  return {
    appearance: queryResult.data || {},
    ...queryResult,
  };
};

const createMutation = (apiCall) => (queryConfig = {}) =>
  useMutation(apiCall, {
    onSuccess: () => notification.success({ message: 'Successfully saved appearance ' }),
    onError: () => notification.error({ message: 'Failed to save appearance' }),
    ...queryConfig,
  });

export const useCreateAppearance = createMutation(api.appearance.create);
export const useUpdateAppearance = createMutation(api.appearance.update);
export const useUpsertAppearance = createMutation(api.appearance.upsert);
